function chooseKfromArray(k, values) {
    var indexArray = [];
    for (let i = 0; i < values.length; i++) {
        indexArray.push(i);
    }

    indexArray.sort(function(){
        return 0.5 - Math.random();
    });

    let ret = [];

    if (k > values.length){
        k = values.length;
    }

    for (let i = 0; i < k; i++) {
        let idx = indexArray[i];
        ret.push(values[idx]);
    }

    return ret;
}

function get_offline_contents() {
    let passage_data = `Europe planned for getting stricken Albania back on to its feet, firming up its support for an aid operation and early elections. In return, Albanian Premier, meeting here with top EU officials, pledged to step up dialogue with the armed rebels who have held the south of the country in their bid to oust President Sali Berisha. A key element of efforts to pull Albania back from the brink involves the dispatch of a multinational force of up to 5,000 troops to shore up security while aid is brought into the chaotic Balkan state.`;
    let passage_ids = [1];
    return {
        passage_ids: passage_ids,
        passage_data: passage_data.split('\n')
    };
}

function loadErrorPassages() {
    let passages = get_offline_contents();
    return passages;
}

async function parsePassages(response, number_of_passages) {
    if (response.status !== 200) {
        console.log('Looks like there was a problem. Status Code: ' +
            response.status);
        return loadErrorPassages();
    }

    const data = await response.json();

    let all_passage_ids = Object.keys(data);
    let selected_passages = chooseKfromArray(number_of_passages, all_passage_ids);
    // Get number_of_passages random passages to show the user.

    let ret = [];

    for (let i = 0; i < selected_passages.length; i++) {
        let passage_id = selected_passages[i];
        const passage = data[passage_id];
        passage["passage_id"] = passage_id;
        ret.push(passage);
        //console.log(passage);
    }
    return ret;
}

async function fetchPassagesWithRetries(n, number_of_passage) {
    //let data_url = "https://eventqa.s3.us-east-2.amazonaws.com/timeml.json";
    //let data_url = "https://eventqa.s3.us-east-2.amazonaws.com/sample_sents_min5_events_min7_tokens_min60_max200_count2679.json";
    let data_url = "https://eventqa.s3.us-east-2.amazonaws.com/sample_sents_min5_events_min5_tokens_min60_max200_count100.json";
    //let data_url = "https://eventqa.s3.us-east-2.amazonaws.com/sample_paper.json";
    //let data_url = "https://eventqa.s3.us-east-2.amazonaws.com/human_baseline.json";
    for (let i = 0; i < n; i++){
        try{
            const response = await fetch(data_url);
            return await parsePassages(response, number_of_passage);
        }catch (e) {
            console.log(e);
        }
    }

    return get_offline_contents();
}

module.exports = {
    parsePassages,
    chooseKfromArray,
    fetchPassagesWithRetries
};